import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import { media, fontWeight, typography, colors, mixins } from '@pik-libs/styles';
import Button from '@pik-libs/button';
import VideoPlayer from '@pik-components/videoplayer';
import { creators, device } from '@pik-libs/utils';
import styled, { css } from 'styled-components';
import Icon from '@pik-libs/icon';
import Ratio from '@pik-libs/ratio';

function _iterableToArrayLimit(arr, i) {
  var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
  if (null != _i) {
    var _s,
      _e,
      _x,
      _r,
      _arr = [],
      _n = !0,
      _d = !1;
    try {
      if (_x = (_i = _i.call(arr)).next, 0 === i) {
        if (Object(_i) !== _i) return;
        _n = !1;
      } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
    } catch (err) {
      _d = !0, _e = err;
    } finally {
      try {
        if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toPrimitive(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}

var createContainerProps = function createContainerProps(props) {
  var result = {};
  try {
    var buttonText = props.buttonText,
      link = props.link,
      targetBlank = props.targetBlank,
      onClick = props.onClick;
    if (!buttonText) {
      if (link) {
        result = {
          as: 'a',
          href: link,
          target: targetBlank ? '_blank' : '_self'
        };
      }
      if (onClick) {
        result = {
          onClick: onClick
        };
      }
    }
  } catch (error) {
    console.error(error);
  }
  return result;
};

var mediaCreator = creators.mediaCreator;
var createBannerMediaProps = function createBannerMediaProps(props) {
  var screenType = props.screenType;
  return {
    image: mediaCreator({
      data: props,
      key: 'image',
      screenType: screenType
    }),
    video: mediaCreator({
      data: props,
      key: 'video',
      screenType: screenType
    })
  };
};

var S$6 = {};
var sizes = {
  xs: {
    desktop: '320px',
    laptop: '320px',
    tablet: '320px',
    mobile: '220px'
  },
  s: {
    desktop: '552px',
    laptop: '512px',
    tablet: '456px',
    mobile: '584px'
  },
  sm: {
    desktop: '553px',
    laptop: '512px',
    tablet: '456px',
    mobile: '366px'
  },
  m: {
    desktop: '608px',
    laptop: '472px',
    tablet: '352px',
    mobile: '256px'
  },
  l: {
    desktop: '624px',
    laptop: '528px',
    tablet: '392px',
    mobile: '256px'
  },
  xl: {
    desktop: '100vh',
    laptop: '100vh',
    tablet: '100vh',
    mobile: '100vh'
  }
};
var stylesByAlign = {
  center: css(["padding:64px;flex-direction:column;margin:0 auto;align-items:center;justify-content:center;text-align:center;@media ", "{padding:16px;}"], media.mobile),
  left: css(["padding:51px 48px;flex-direction:column;align-items:flex-start;justify-content:space-between;text-align:left;@media ", "{padding:24px 16px;}"], media.mobile),
  bottom: css(["padding:40px;align-items:flex-end;justify-content:space-between;"])
};
var componentsStyles = {
  title: {
    "default": '',
    plus: css(["font-size:88px;line-height:88px;letter-spacing:-0.04em;font-weight:", ";max-width:746px;@media ", "{font-size:64px;line-height:64px;}@media ", "{font-size:28px;line-height:28px;max-width:none;}"], fontWeight.medium, media.tablet, media.mobile)
  },
  description: {
    "default": '',
    plus: css(["font-size:64px;line-height:64px;letter-spacing:-0.04em;font-weight:", ";margin-top:0;max-width:746px;@media ", "{font-size:28px;line-height:28px;max-width:none;}"], fontWeight.medium, media.mobile)
  }
};
var getComponentStyles = function getComponentStyles(props, component) {
  var styleType = props.styleType;
  if (component && componentsStyles[component]) {
    var currentStyles = componentsStyles[component];
    if (styleType && currentStyles[styleType]) {
      return currentStyles[styleType];
    }
  }
  return '';
};
S$6.BannerContainer = styled.div.withConfig({
  displayName: "styles__BannerContainer",
  componentId: "sc-9ki7wb-0"
})(function (_ref) {
  var image = _ref.image,
    show = _ref.show,
    roundedCorners = _ref.roundedCorners,
    backgroundColor = _ref.backgroundColor;
  return css(["display:block;width:100%;", ";", ";background-repeat:no-repeat;background-size:cover;background-blend-mode:multiply;background-position:50%;overflow:hidden;-webkit-mask-image:-webkit-radial-gradient(white,black);transition-duration:0.7s;transition-timing-function:ease;transition-property:opacity;text-decoration:none;opacity:", ";", ";"], image && css(["background-image:url('", "');"], image), backgroundColor && css(["background-color:", ";"], backgroundColor), show ? 1 : 0, roundedCorners && css(["border-radius:8px;"]));
});
S$6.BannerBlackout = styled.div.withConfig({
  displayName: "styles__BannerBlackout",
  componentId: "sc-9ki7wb-1"
})(function (_ref2) {
  var withOverlay = _ref2.withOverlay;
  return css(["position:relative;width:100%;height:100%;", ""], withOverlay ? css(["background-color:rgba(0,0,0,0.2);"]) : '');
});
S$6.BannerWrapper = styled.div.withConfig({
  displayName: "styles__BannerWrapper",
  componentId: "sc-9ki7wb-2"
})(function (_ref3) {
  var size = _ref3.size,
    height = _ref3.height,
    align = _ref3.align;
  return css(["box-sizing:border-box;display:flex;", ";", ";"], size && !height ? css(["min-height:", ";@media ", "{min-height:", ";}@media ", "{min-height:", ";}@media ", "{min-height:", ";}"], sizes[size].desktop, media.laptop, sizes[size].laptop, media.tablet, sizes[size].tablet, media.mobile, sizes[size].mobile) : css(["min-height:", ";"], height), stylesByAlign[align]);
});
S$6.BannerTextWrapper = styled.div.withConfig({
  displayName: "styles__BannerTextWrapper",
  componentId: "sc-9ki7wb-3"
})(function (_ref4) {
  var align = _ref4.align;
  return css(["display:flex;flex-direction:column;", ""], align === 'center' && css(["align-items:center;"]));
});
S$6.BannerTitle = styled.h2.withConfig({
  displayName: "styles__BannerTitle",
  componentId: "sc-9ki7wb-4"
})(function (props) {
  var align = props.align,
    titleColor = props.titleColor;
  return css(["", ";color:", ";font-weight:", ";white-space:pre-wrap;@media ", "{", ";}", ";"], align === 'bottom' ? typography.l : typography.xxxl, titleColor, fontWeight.medium, media.tablet, typography.xl, getComponentStyles(props, 'title'));
});
S$6.BannerDescription = styled.div.withConfig({
  displayName: "styles__BannerDescription",
  componentId: "sc-9ki7wb-5"
})(function (props) {
  var align = props.align,
    descriptionColor = props.descriptionColor;
  return css(["margin-top:16px;max-width:384px;", ";color:", ";font-weight:", ";", ";"], align === 'bottom' ? typography.m : typography.body, descriptionColor, fontWeight.normal, getComponentStyles(props, 'description'));
});
S$6.BannerButton = styled.div.withConfig({
  displayName: "styles__BannerButton",
  componentId: "sc-9ki7wb-6"
})(["white-space:nowrap;margin-top:32px;@media ", "{margin-top:24px;}"], media.tablet);
S$6.BannerVideo = styled.div.withConfig({
  displayName: "styles__BannerVideo",
  componentId: "sc-9ki7wb-7"
})(["position:absolute;top:0;right:0;bottom:0;left:0;z-index:-1;"]);

var SHOWING_BOTTOM_START = 200;
var renderTitle = function renderTitle(_ref) {
  var title = _ref.title,
    titleColor = _ref.titleColor,
    align = _ref.align,
    styleType = _ref.styleType;
  if (title) {
    return /*#__PURE__*/React.createElement(S$6.BannerTitle, {
      align: align,
      styleType: styleType,
      titleColor: titleColor,
      dangerouslySetInnerHTML: {
        __html: title
      }
    });
  }
  return null;
};
var renderDescription = function renderDescription(_ref2) {
  var description = _ref2.description,
    descriptionColor = _ref2.descriptionColor,
    align = _ref2.align,
    styleType = _ref2.styleType;
  if (description) {
    return /*#__PURE__*/React.createElement(S$6.BannerDescription, {
      align: align,
      styleType: styleType,
      descriptionColor: descriptionColor,
      dangerouslySetInnerHTML: {
        __html: description
      }
    });
  }
  return null;
};
var renderButton = function renderButton(_ref3) {
  var buttonProps = _ref3.buttonProps,
    buttonText = _ref3.buttonText,
    link = _ref3.link,
    targetBlank = _ref3.targetBlank,
    onClick = _ref3.onClick;
  var buttonComponentProps = _objectSpread2({
    type: 'default',
    size: 'l',
    color: 'black'
  }, buttonProps);
  if (link) {
    buttonComponentProps = _objectSpread2(_objectSpread2({}, buttonComponentProps), {}, {
      href: link,
      targetBlank: targetBlank
    });
  } else if (onClick) {
    buttonComponentProps = _objectSpread2(_objectSpread2({}, buttonComponentProps), {}, {
      onClick: onClick
    });
  }
  return /*#__PURE__*/React.createElement(S$6.BannerButton, null, /*#__PURE__*/React.createElement(Button, buttonComponentProps, buttonText));
};
var renderVideo = function renderVideo(_ref4) {
  var video = _ref4.video,
    image = _ref4.image;
  if (video) {
    var videoPlayerProps = {
      src: video,
      poster: image
    };
    return /*#__PURE__*/React.createElement(S$6.BannerVideo, null, /*#__PURE__*/React.createElement(VideoPlayer, videoPlayerProps));
  }
  return null;
};
var Banner$1 = function Banner(props) {
  var size = props.size,
    withOverlay = props.withOverlay,
    title = props.title,
    description = props.description,
    titleColor = props.titleColor,
    descriptionColor = props.descriptionColor,
    className = props.className,
    align = props.align,
    roundedCorners = props.roundedCorners,
    height = props.height,
    isAnimated = props.isAnimated,
    buttonProps = props.buttonProps,
    buttonText = props.buttonText,
    link = props.link,
    onClick = props.onClick,
    backgroundColor = props.backgroundColor,
    targetBlank = props.targetBlank,
    styleType = props.styleType;
  var initialShow = !isAnimated;
  var _useState = useState(initialShow),
    _useState2 = _slicedToArray(_useState, 2),
    show = _useState2[0],
    setShow = _useState2[1];
  var ref = useRef(null);
  var onScroll = function onScroll() {
    if (ref && ref.current && window && !show && ref.current.offsetTop !== 0) {
      var bannerTop = ref.current.offsetTop;
      var pageY = window.pageYOffset;
      var screenHeight = window.screen.height;
      if (pageY + screenHeight >= bannerTop + SHOWING_BOTTOM_START) {
        setShow(true);
      }
    }
  };
  useEffect(function () {
    if (isAnimated && window) {
      onScroll();
      window.addEventListener('scroll', onScroll);
    } else {
      setShow(true);
    }
    return function () {
      if (isAnimated && window) {
        window.removeEventListener('scroll', onScroll);
      }
    };
  }, [ref]);
  var hasButton = !!buttonText;
  var _createBannerMediaPro = createBannerMediaProps(props),
    image = _createBannerMediaPro.image,
    video = _createBannerMediaPro.video;
  var createdContainerProps = createContainerProps(props);
  var containerProps = _objectSpread2({
    roundedCorners: roundedCorners,
    className: className,
    show: show,
    ref: ref,
    backgroundColor: !video && !image ? backgroundColor : null,
    image: !video ? image : null
  }, createdContainerProps);
  return /*#__PURE__*/React.createElement(S$6.BannerContainer, containerProps, /*#__PURE__*/React.createElement(S$6.BannerBlackout, {
    withOverlay: withOverlay,
    show: show
  }, renderVideo({
    video: video,
    image: image
  }), /*#__PURE__*/React.createElement(S$6.BannerWrapper, {
    size: size,
    align: align,
    height: height
  }, /*#__PURE__*/React.createElement(S$6.BannerTextWrapper, {
    align: align
  }, renderTitle({
    title: title,
    titleColor: titleColor,
    align: align,
    styleType: styleType
  }), renderDescription({
    description: description,
    descriptionColor: descriptionColor,
    align: align,
    styleType: styleType
  })), hasButton && renderButton({
    buttonProps: buttonProps,
    buttonText: buttonText,
    link: link,
    targetBlank: targetBlank,
    onClick: onClick
  }))));
};
Banner$1.propTypes = {
  size: PropTypes.string,
  image: PropTypes.shape({}),
  video: PropTypes.shape({}),
  withOverlay: PropTypes.bool,
  title: PropTypes.string,
  description: PropTypes.string,
  titleColor: PropTypes.string,
  descriptionColor: PropTypes.string,
  backgroundColor: PropTypes.string,
  buttonProps: PropTypes.shape({}),
  buttonText: PropTypes.string,
  styleType: PropTypes.oneOf(['default', 'plus']),
  link: PropTypes.string,
  targetBlank: PropTypes.bool,
  onClick: PropTypes.func,
  className: PropTypes.string,
  align: PropTypes.oneOf(['center', 'left', 'bottom']),
  roundedCorners: PropTypes.bool,
  height: PropTypes.string,
  isAnimated: PropTypes.bool,
  screenType: PropTypes.shape({}).isRequired
};
Banner$1.defaultProps = {
  className: '',
  title: null,
  description: null,
  titleColor: colors.white,
  descriptionColor: colors.white,
  backgroundColor: null,
  buttonProps: {},
  buttonText: null,
  styleType: 'default',
  link: null,
  targetBlank: false,
  onClick: null,
  size: 'm',
  align: 'center',
  roundedCorners: true,
  image: null,
  video: null,
  withOverlay: false,
  height: null,
  isAnimated: false
};

var S$5 = {};
S$5.TopMenuBanner = styled.div.withConfig({
  displayName: "styles__TopMenuBanner",
  componentId: "sc-1hknvgh-0"
})(["position:relative;width:100%;height:48px;box-sizing:border-box;"]);
S$5.Arrow = styled.div.withConfig({
  displayName: "styles__Arrow",
  componentId: "sc-1hknvgh-1"
})(["box-sizing:border-box;margin-left:4px;opacity:1;"]);
S$5.Link = styled.a.withConfig({
  displayName: "styles__Link",
  componentId: "sc-1hknvgh-2"
})(function (_ref) {
  var textColor = _ref.textColor;
  return css(["", " position:relative;width:100%;height:100%;box-sizing:border-box;text-decoration:none;color:", ";", "{.Icon{svg path{fill:", ";}}}"], mixins.flex('row', 'nowrap', 'center', 'center'), textColor, S$5.Arrow, textColor);
});
S$5.Wrapper = styled.div.withConfig({
  displayName: "styles__Wrapper",
  componentId: "sc-1hknvgh-3"
})(["box-sizing:border-box;", ""], mixins.flex('row', 'nowrap', 'center', 'center'));
S$5.Title = styled.span.withConfig({
  displayName: "styles__Title",
  componentId: "sc-1hknvgh-4"
})(["box-sizing:border-box;", ";"], typography.s);

var DOMAIN = 'https://old.pik.ru';
var getLink = function getLink(baseUrl) {
  var locationSlug = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var complexSlug = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var flatId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
  if (typeof window !== 'undefined') {
    var _window$location = window.location,
      search = _window$location.search,
      pathname = _window$location.pathname;
    var query = String(search).replace('?type=1', '?flatsOnly=1').replace('&type=1', '&flatsOnly=1').replace('?type=2', '?apartmentsOnly=1').replace('&type=2', '&apartmentsOnly=1').replace('?registration=2', '?location=2').replace('&registration=2', '&location=2').replace('?registration=3', '?location=3').replace('&registration=3', '&location=3');
    if (flatId && complexSlug) {
      // flatPage
      switch (pathname) {
        case "/flat/".concat(flatId):
          return "".concat(DOMAIN, "/").concat(complexSlug, "/flats/").concat(flatId).concat(query);
        case "/commercial/".concat(flatId):
          return "".concat(DOMAIN, "/business/search/").concat(complexSlug, "/").concat(flatId).concat(query);
      }
    }
    if (complexSlug) {
      switch (pathname) {
        // complexPage
        case "/".concat(complexSlug):
          return "".concat(DOMAIN, "/").concat(complexSlug).concat(query);
        case "/".concat(locationSlug, "/").concat(complexSlug):
          return "".concat(DOMAIN, "/").concat(locationSlug, "/").concat(complexSlug).concat(query);
        // business/search/${complexSlug}
        case "/business/search/".concat(complexSlug):
          return "".concat(DOMAIN, "/business/search/").concat(complexSlug).concat(query);
        case "/business/".concat(locationSlug, "/search/").concat(complexSlug):
          return "".concat(DOMAIN, "/business/").concat(locationSlug, "/search/").concat(complexSlug).concat(query);
      }
    }
    switch (pathname) {
      // live
      case '/live':
        return "".concat(DOMAIN, "/live").concat(query);
      case "/".concat(locationSlug, "/live"):
        return "".concat(DOMAIN, "/").concat(locationSlug, "/live").concat(query);
      // mortgage
      case '/mortgage':
        return "".concat(DOMAIN, "/mortgage/about").concat(query);
      case "/".concat(locationSlug, "/mortgage"):
        return "".concat(DOMAIN, "/").concat(locationSlug, "/mortgage/about").concat(query);
      // projects
      case '/projects':
        return "".concat(DOMAIN, "/projects").concat(query);
      case "/".concat(locationSlug, "/projects"):
        return "".concat(DOMAIN, "/").concat(locationSlug, "/projects").concat(query);
      // search
      case '/search':
        return "".concat(DOMAIN, "/search").concat(query);
      case "/search/".concat(locationSlug):
        return "".concat(DOMAIN, "/search/").concat(locationSlug).concat(query);
      // search/cars
      case '/search/cars':
        return "".concat(DOMAIN, "/search/cars").concat(query);
      case "/search/".concat(locationSlug, "/cars"):
        return "".concat(DOMAIN, "/search/").concat(locationSlug, "/cars").concat(query);
      // search/storehouse
      case '/search/storehouse':
        return "".concat(DOMAIN, "/search/storehouse").concat(query);
      case "/search/".concat(locationSlug, "/storehouse"):
        return "".concat(DOMAIN, "/search/").concat(locationSlug, "/storehouse").concat(query);
      // business/search
      case '/business/search':
        return "".concat(DOMAIN, "/business/projects").concat(query);
      case "/business/".concat(locationSlug, "/search"):
        return "".concat(DOMAIN, "/business/").concat(locationSlug, "/projects").concat(query);
    }
  }
  return baseUrl;
};
var TopMenuBanner = function TopMenuBanner(_ref) {
  var className = _ref.className,
    title = _ref.title,
    link = _ref.link,
    targetBlank = _ref.targetBlank,
    textColor = _ref.textColor,
    complexSlug = _ref.complexSlug,
    locationSlug = _ref.locationSlug,
    flatId = _ref.flatId;
  var target = targetBlank ? '_blank' : undefined;
  var href = getLink(link, locationSlug, complexSlug, flatId);
  return /*#__PURE__*/React.createElement(S$5.TopMenuBanner, {
    className: className
  }, /*#__PURE__*/React.createElement(S$5.Link, {
    href: href,
    target: target,
    textColor: textColor
  }, /*#__PURE__*/React.createElement(S$5.Wrapper, null, !!title && /*#__PURE__*/React.createElement(S$5.Title, {
    dangerouslySetInnerHTML: {
      __html: title
    }
  }), /*#__PURE__*/React.createElement(S$5.Arrow, null, /*#__PURE__*/React.createElement(Icon, {
    name: "chevronR",
    size: "s"
  })))));
};
TopMenuBanner.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string,
  link: PropTypes.string,
  targetBlank: PropTypes.bool,
  textColor: PropTypes.string,
  complexSlug: PropTypes.string,
  locationSlug: PropTypes.string,
  flatId: PropTypes.number
};
TopMenuBanner.defaultProps = {
  className: undefined,
  title: null,
  link: null,
  targetBlank: false,
  textColor: colors.black,
  locationSlug: '',
  complexSlug: null,
  flatId: null
};

var S$4 = {};
S$4.SearchHeadBanner = styled.a.withConfig({
  displayName: "styles__SearchHeadBanner",
  componentId: "sc-47ymqe-0"
})(function (_ref) {
  var backgroundColor = _ref.backgroundColor;
  return css(["", ";width:100%;background:", ";box-sizing:border-box;padding:12px 16px;border-radius:8px;@media ", "{justify-content:initial;padding:8px 16px 8px 8px;}"], mixins.flex(), backgroundColor, media.mobile);
});
S$4.Content = styled.div.withConfig({
  displayName: "styles__Content",
  componentId: "sc-47ymqe-1"
})(["", ";width:100%;@media ", "{justify-content:initial;}"], mixins.flex('row', 'nowrap', 'center', 'center'), media.mobile);
S$4.BannerIcon = styled.div.withConfig({
  displayName: "styles__BannerIcon",
  componentId: "sc-47ymqe-2"
})(["", ";height:24px;box-sizing:border-box;margin-right:8px;.Icon{svg path{fill:", ";}}@media ", "{margin-right:12px;}"], mixins.flexWidth('24px'), colors.white, media.mobile);
S$4.BannerTitle = styled.div.withConfig({
  displayName: "styles__BannerTitle",
  componentId: "sc-47ymqe-3"
})(function (_ref2) {
  var textColor = _ref2.textColor;
  return css(["color:", ";", ";@media ", "{max-width:148px;", ";}"], textColor, typography.s, media.mobile, typography.xs);
});
S$4.BannerClose = styled.div.withConfig({
  displayName: "styles__BannerClose",
  componentId: "sc-47ymqe-4"
})(["cursor:pointer;.Icon{svg path{fill:", ";}}"], colors.white);

var SearchHeadBanner = function SearchHeadBanner(_ref) {
  var className = _ref.className,
    title = _ref.title,
    link = _ref.link,
    targetBlank = _ref.targetBlank,
    textColor = _ref.textColor,
    backgroundColor = _ref.backgroundColor,
    iconName = _ref.iconName,
    onClose = _ref.onClose;
  var target = targetBlank ? '_blank' : undefined;
  return /*#__PURE__*/React.createElement(S$4.SearchHeadBanner, {
    className: className,
    backgroundColor: backgroundColor,
    href: link,
    target: target
  }, /*#__PURE__*/React.createElement(S$4.Content, null, !!iconName && /*#__PURE__*/React.createElement(S$4.BannerIcon, null, /*#__PURE__*/React.createElement(Icon, {
    name: iconName
  })), !!title && /*#__PURE__*/React.createElement(S$4.BannerTitle, {
    textColor: textColor,
    dangerouslySetInnerHTML: {
      __html: title
    }
  })), onClose && /*#__PURE__*/React.createElement(S$4.BannerClose, {
    onClick: onClose
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "cross",
    size: "s"
  })));
};
SearchHeadBanner.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string,
  link: PropTypes.string,
  textColor: PropTypes.string,
  backgroundColor: PropTypes.string,
  iconName: PropTypes.string,
  targetBlank: PropTypes.bool,
  onClose: PropTypes.func
};
SearchHeadBanner.defaultProps = {
  className: undefined,
  title: null,
  link: null,
  textColor: null,
  backgroundColor: null,
  iconName: null,
  targetBlank: false,
  onClose: null
};

var S$3 = {};
S$3.SpecialOfferBanner = styled.a.withConfig({
  displayName: "styles__SpecialOfferBanner",
  componentId: "sc-1tknpqi-0"
})(function (_ref) {
  var backgroundColor = _ref.backgroundColor;
  return css(["", ";width:100%;background:", ";box-sizing:border-box;padding:24px 16px;border-radius:8px;text-decoration:none;"], mixins.flex(), backgroundColor);
});
S$3.Content = styled.div.withConfig({
  displayName: "styles__Content",
  componentId: "sc-1tknpqi-1"
})(["", ";width:100%;text-align:center;"], mixins.flex('row', 'wrap', 'center', 'center'));
S$3.BannerTitle = styled.div.withConfig({
  displayName: "styles__BannerTitle",
  componentId: "sc-1tknpqi-2"
})(function (_ref2) {
  var titleColor = _ref2.titleColor;
  return css(["color:", ";font-size:24px;line-height:32px;&:not(:last-of-type){margin-right:16px;}@media ", "{font-size:20px;line-height:26px;&:not(:last-of-type){margin-right:6px;}}"], titleColor, media.mobile);
});
S$3.BannerDescription = styled.div.withConfig({
  displayName: "styles__BannerDescription",
  componentId: "sc-1tknpqi-3"
})(function (_ref3) {
  var titleColor = _ref3.titleColor,
    descriptionColor = _ref3.descriptionColor;
  return css(["color:", ";span{color:", ";}font-size:24px;line-height:32px;@media ", "{font-size:20px;line-height:26px;}"], titleColor, descriptionColor, media.mobile);
});

var SpecialOfferBanner = function SpecialOfferBanner(_ref) {
  var className = _ref.className,
    title = _ref.title,
    description = _ref.description,
    link = _ref.link,
    targetBlank = _ref.targetBlank,
    titleColor = _ref.titleColor,
    descriptionColor = _ref.descriptionColor,
    backgroundColor = _ref.backgroundColor;
  var target = targetBlank ? '_blank' : undefined;
  return /*#__PURE__*/React.createElement(S$3.SpecialOfferBanner, {
    className: className,
    backgroundColor: backgroundColor,
    href: link,
    target: target
  }, /*#__PURE__*/React.createElement(S$3.Content, null, !!title && /*#__PURE__*/React.createElement(S$3.BannerTitle, {
    titleColor: titleColor,
    dangerouslySetInnerHTML: {
      __html: title
    }
  }), !!description && /*#__PURE__*/React.createElement(S$3.BannerDescription, {
    titleColor: titleColor,
    descriptionColor: descriptionColor,
    dangerouslySetInnerHTML: {
      __html: description
    }
  })));
};
SpecialOfferBanner.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.string,
  link: PropTypes.string,
  titleColor: PropTypes.string,
  descriptionColor: PropTypes.string,
  backgroundColor: PropTypes.string,
  targetBlank: PropTypes.bool
};
SpecialOfferBanner.defaultProps = {
  className: undefined,
  title: null,
  description: null,
  link: null,
  titleColor: colors.white,
  descriptionColor: 'rgba(255, 255, 255, 0.4)',
  backgroundColor: null,
  targetBlank: false
};

var createRatioProps = function createRatioProps(props) {
  var ratio = props.ratio,
    screenType = props.screenType;
  if (ratio && Object.keys(ratio).length && screenType) {
    var screenTypeString = device.getScreenTypeString(screenType);
    if (screenTypeString) {
      var currentRatio = ratio[screenTypeString];
      if (!currentRatio) {
        currentRatio = ratio.isDesktop;
      }
      if (Array.isArray(currentRatio)) {
        var _currentRatio = currentRatio,
          _currentRatio2 = _slicedToArray(_currentRatio, 2),
          width = _currentRatio2[0],
          height = _currentRatio2[1];
        return {
          width: width,
          height: height
        };
      }
    }
  }
  return {};
};

var S$2 = {};
S$2.RatioBanner = styled.div.withConfig({
  displayName: "styles__RatioBanner",
  componentId: "sc-5hu45z-0"
})(["width:100%;"]);
S$2.RatioBannerContainer = styled.div.withConfig({
  displayName: "styles__RatioBannerContainer",
  componentId: "sc-5hu45z-1"
})(function (_ref) {
  var backgroundColor = _ref.backgroundColor,
    image = _ref.image;
  return css(["width:100%;height:100%;border-radius:12px;", ";", ";@media ", "{border-radius:8px;}"], backgroundColor && css(["background-color:", ";"], backgroundColor), image && css(["background-image:url('", "');background-repeat:no-repeat;background-position:bottom right;background-size:contain;"], image), media.mobile);
});
S$2.Content = styled.div.withConfig({
  displayName: "styles__Content",
  componentId: "sc-5hu45z-2"
})(["", ";width:100%;height:100%;box-sizing:border-box;padding:16px 48px;@media ", "{", ";padding:16px;}"], mixins.flex('column', 'nowrap', 'center', 'initial'), media.mobile, mixins.flex('column', 'nowrap', 'initial', 'initial'));
S$2.Title = styled.div.withConfig({
  displayName: "styles__Title",
  componentId: "sc-5hu45z-3"
})(function (_ref2) {
  var titleColor = _ref2.titleColor;
  return css(["font-size:32px;line-height:48px;text-decoration:none;font-weight:", ";", ";@media ", "{font-size:24px;line-height:32px;}"], fontWeight.medium, titleColor && css(["color:", ";"], titleColor), media.mobile);
});
S$2.Description = styled.div.withConfig({
  displayName: "styles__Description",
  componentId: "sc-5hu45z-4"
})(function (_ref3) {
  var descriptionColor = _ref3.descriptionColor;
  return css(["width:100%;max-width:308px;font-size:24px;line-height:34px;text-decoration:none;font-weight:", ";", ";@media ", "{max-width:285px;font-size:24px;line-height:32px;}"], fontWeight.medium, descriptionColor && css(["color:", ";"], descriptionColor), media.mobile);
});
S$2.ButtonWrapper = styled.div.withConfig({
  displayName: "styles__ButtonWrapper",
  componentId: "sc-5hu45z-5"
})(["margin-top:28px;@media ", "{margin-top:24px;}"], media.mobile);

var RatioBanner = function RatioBanner(props) {
  var title = props.title,
    description = props.description,
    link = props.link,
    targetBlank = props.targetBlank,
    buttonText = props.buttonText,
    titleColor = props.titleColor,
    descriptionColor = props.descriptionColor,
    backgroundColor = props.backgroundColor;
  var createdContainerProps = createContainerProps(props);
  var ratioProps = createRatioProps(props);
  var _createBannerMediaPro = createBannerMediaProps(props),
    image = _createBannerMediaPro.image;
  var containerProps = _objectSpread2(_objectSpread2({}, createdContainerProps), {}, {
    backgroundColor: backgroundColor,
    image: image
  });
  return /*#__PURE__*/React.createElement(S$2.RatioBanner, null, /*#__PURE__*/React.createElement(Ratio, ratioProps, /*#__PURE__*/React.createElement(S$2.RatioBannerContainer, containerProps, /*#__PURE__*/React.createElement(S$2.Content, null, /*#__PURE__*/React.createElement(S$2.Title, {
    titleColor: titleColor,
    dangerouslySetInnerHTML: {
      __html: title
    }
  }), /*#__PURE__*/React.createElement(S$2.Description, {
    descriptionColor: descriptionColor,
    dangerouslySetInnerHTML: {
      __html: description
    }
  }), !!buttonText && /*#__PURE__*/React.createElement(S$2.ButtonWrapper, null, /*#__PURE__*/React.createElement(Button, {
    href: link,
    targetBlank: targetBlank,
    size: "s"
  }, buttonText))))));
};
RatioBanner.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  link: PropTypes.string,
  targetBlank: PropTypes.bool,
  buttonText: PropTypes.string,
  titleColor: PropTypes.string,
  descriptionColor: PropTypes.string,
  ratio: PropTypes.shape({}).isRequired,
  backgroundColor: PropTypes.string
};
RatioBanner.defaultProps = {
  title: null,
  description: null,
  link: null,
  targetBlank: false,
  buttonText: null,
  titleColor: null,
  descriptionColor: null,
  backgroundColor: null
};

var S$1 = {};
S$1.ColorBanner = styled.div.withConfig({
  displayName: "styles__ColorBanner",
  componentId: "qddzrn-0"
})(["width:100%;"]);
S$1.ColorBannerContainer = styled.div.withConfig({
  displayName: "styles__ColorBannerContainer",
  componentId: "qddzrn-1"
})(function (_ref) {
  var backgroundColor = _ref.backgroundColor,
    image = _ref.image;
  return css(["display:block;width:100%;height:100%;border-radius:8px;box-sizing:border-box;", ";", ";"], backgroundColor && css(["background-color:", ";"], backgroundColor), image && css(["background-image:url('", "');background-repeat:no-repeat;background-position:bottom right;background-size:contain;"], image));
});
S$1.Content = styled.div.withConfig({
  displayName: "styles__Content",
  componentId: "qddzrn-2"
})(["", ";width:100%;height:100%;box-sizing:border-box;padding:48px;@media ", "{padding:24px 16px;}"], mixins.flex('column', 'nowrap', 'center', 'initial'), media.mobile);
S$1.Title = styled.div.withConfig({
  displayName: "styles__Title",
  componentId: "qddzrn-3"
})(function (_ref2) {
  var titleColor = _ref2.titleColor,
    descriptionColor = _ref2.descriptionColor,
    largeTitle = _ref2.largeTitle;
  return css(["font-size:40px;line-height:40px;letter-spacing:-0.04em;text-decoration:none;font-weight:", ";", ";", ";", ";@media ", "{font-size:32px;line-height:32px;letter-spacing:-0.04em;}"], fontWeight.medium, largeTitle && css(["font-size:64px;line-height:64px;letter-spacing:-2.56px;"]), titleColor && css(["color:", ";"], titleColor), descriptionColor && css(["span{color:", ";}"], descriptionColor), media.mobile);
});
S$1.Description = styled.div.withConfig({
  displayName: "styles__Description",
  componentId: "qddzrn-4"
})(function (_ref3) {
  var titleColor = _ref3.titleColor,
    descriptionColor = _ref3.descriptionColor;
  return css(["width:100%;font-size:24px;line-height:34px;text-decoration:none;font-weight:", ";margin-top:16px;", ";", ";@media ", "{font-size:24px;line-height:32px;}"], fontWeight.medium, titleColor && css(["color:", ";"], titleColor), descriptionColor && css(["span{color:", ";}"], descriptionColor), media.mobile);
});
S$1.ButtonWrapper = styled.div.withConfig({
  displayName: "styles__ButtonWrapper",
  componentId: "qddzrn-5"
})(["margin-top:32px;@media ", "{margin-top:20px;}"], media.mobile);

var ColorBanner = function ColorBanner(props) {
  var title = props.title,
    largeTitle = props.largeTitle,
    description = props.description,
    link = props.link,
    targetBlank = props.targetBlank,
    onClick = props.onClick,
    buttonText = props.buttonText,
    titleColor = props.titleColor,
    descriptionColor = props.descriptionColor,
    backgroundColor = props.backgroundColor;
  var createdContainerProps = createContainerProps(props);
  var _createBannerMediaPro = createBannerMediaProps(props),
    image = _createBannerMediaPro.image;
  var containerProps = _objectSpread2(_objectSpread2({}, createdContainerProps), {}, {
    backgroundColor: backgroundColor,
    image: image
  });
  var buttonProps = {
    size: 'm'
  };
  if (link) {
    buttonProps = _objectSpread2(_objectSpread2({}, buttonProps), {}, {
      href: link,
      targetBlank: targetBlank
    });
  }
  if (onClick) {
    buttonProps = _objectSpread2(_objectSpread2({}, buttonProps), {}, {
      link: undefined,
      targetBlank: undefined,
      onClick: onClick
    });
  }
  return /*#__PURE__*/React.createElement(S$1.ColorBanner, null, /*#__PURE__*/React.createElement(S$1.ColorBannerContainer, containerProps, /*#__PURE__*/React.createElement(S$1.Content, null, /*#__PURE__*/React.createElement(S$1.Title, {
    titleColor: titleColor,
    descriptionColor: descriptionColor,
    largeTitle: largeTitle,
    dangerouslySetInnerHTML: {
      __html: title
    }
  }), !!description && /*#__PURE__*/React.createElement(S$1.Description, {
    titleColor: titleColor,
    descriptionColor: descriptionColor,
    dangerouslySetInnerHTML: {
      __html: description
    }
  }), !!buttonText && /*#__PURE__*/React.createElement(S$1.ButtonWrapper, null, /*#__PURE__*/React.createElement(Button, buttonProps, buttonText)))));
};
ColorBanner.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  link: PropTypes.string,
  targetBlank: PropTypes.bool,
  largeTitle: PropTypes.bool,
  buttonText: PropTypes.string,
  titleColor: PropTypes.string,
  descriptionColor: PropTypes.string,
  backgroundColor: PropTypes.string,
  onClick: PropTypes.func
};
ColorBanner.defaultProps = {
  title: null,
  description: null,
  link: null,
  targetBlank: false,
  largeTitle: false,
  buttonText: null,
  titleColor: null,
  descriptionColor: 'rgba(255, 255, 255, 0.75)',
  backgroundColor: null,
  onClick: undefined
};

var S = {};
S.AntiFraudBanner = styled.div.withConfig({
  displayName: "styles__AntiFraudBanner",
  componentId: "mivsxg-0"
})(function (_ref) {
  var backgroundColor = _ref.backgroundColor;
  return css(["", ";position:relative;width:100%;min-height:56px;box-sizing:border-box;padding:8px 24px;background:", ";text-decoration:none;border-radius:8px;@media ", "{display:block;padding:16px;}"], mixins.flex('row', 'nowrap', 'space-between', 'center'), backgroundColor, media.mobile);
});
S.Content = styled.div.withConfig({
  displayName: "styles__Content",
  componentId: "mivsxg-1"
})(["", ";width:100%;@media ", "{display:block;}"], mixins.flex('row', 'nowrap', 'center', 'center'), media.mobile);
S.BannerTitle = styled.div.withConfig({
  displayName: "styles__BannerTitle",
  componentId: "mivsxg-2"
})(function (_ref2) {
  var textColor = _ref2.textColor;
  return css(["color:", ";font-size:16px;line-height:22px;letter-spacing:-0.001em;box-sizing:border-box;span{font-weight:", ";}@media ", "{padding-right:24px;}"], textColor, fontWeight.medium, media.mobile);
});
S.BannerButton = styled.a.withConfig({
  displayName: "styles__BannerButton",
  componentId: "mivsxg-3"
})(function (_ref3) {
  var buttonColor = _ref3.buttonColor;
  return css(["", ";position:relative;height:40px;box-sizing:border-box;padding:0 16px;border-radius:32px;margin-left:24px;text-decoration:none;color:", ";cursor:pointer;&:after{position:absolute;content:'';top:0;right:0;bottom:0;left:0;pointer-events:none;border:1px solid ", ";border-radius:32px;}@media ", "{margin-left:0;margin-top:8px;}"], mixins.flex(), buttonColor, buttonColor, media.mobile);
});
S.BannerClose = styled.div.withConfig({
  displayName: "styles__BannerClose",
  componentId: "mivsxg-4"
})(function (_ref4) {
  var textColor = _ref4.textColor;
  return css(["", ";cursor:pointer;margin-left:16px;.Icon{svg path{fill:", ";}}@media ", "{position:absolute;top:12px;right:12px;width:16px;height:16px;margin-left:0;}"], mixins.flex(), textColor, media.mobile);
});

var AntiFraudBanner = function AntiFraudBanner(_ref) {
  var className = _ref.className,
    title = _ref.title,
    textColor = _ref.textColor,
    backgroundColor = _ref.backgroundColor,
    button = _ref.button,
    onClose = _ref.onClose;
  return /*#__PURE__*/React.createElement(S.AntiFraudBanner, {
    className: className,
    backgroundColor: backgroundColor
  }, /*#__PURE__*/React.createElement(S.Content, null, !!title && /*#__PURE__*/React.createElement(S.BannerTitle, {
    textColor: textColor,
    dangerouslySetInnerHTML: {
      __html: title
    }
  }), !!button && /*#__PURE__*/React.createElement(S.BannerButton, {
    href: button.link,
    target: button.targetBlank ? '_blank' : '_self',
    buttonColor: button.buttonColor
  }, button.text)), onClose && /*#__PURE__*/React.createElement(S.BannerClose, {
    onClick: onClose,
    textColor: textColor
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "cross",
    size: "s"
  })));
};
AntiFraudBanner.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string,
  textColor: PropTypes.string,
  backgroundColor: PropTypes.string,
  button: PropTypes.shape({
    link: PropTypes.string,
    targetBlank: PropTypes.bool,
    text: PropTypes.string,
    buttonColor: PropTypes.string
  }),
  onClose: PropTypes.func
};
AntiFraudBanner.defaultProps = {
  className: undefined,
  title: null,
  textColor: null,
  backgroundColor: null,
  button: null,
  onClose: null
};

var _excluded = ["type"];
var COMPONENTS = {
  "default": Banner$1,
  topMenu: TopMenuBanner,
  searchHead: SearchHeadBanner,
  specialOffer: SpecialOfferBanner,
  ratio: RatioBanner,
  color: ColorBanner,
  antiFraud: AntiFraudBanner
};
var Banner = function Banner(_ref) {
  var type = _ref.type,
    props = _objectWithoutProperties(_ref, _excluded);
  var Component = type ? COMPONENTS[type] : null;
  if (Component) {
    return /*#__PURE__*/React.createElement(Component, props);
  }
  return null;
};
Banner.propTypes = {
  type: PropTypes.oneOf(['default', 'topMenu', 'searchHead', 'specialOffer', 'ratio', 'color', 'antiFraudBanner'])
};
Banner.defaultProps = {
  type: 'default'
};

export { Banner as default };
